import { instance } from 'utils/api';

// POST /translations/translate {lang, body[]} → bare {lang, body[]} (DeepL,
// source auto-detected, per-item order preserved).
export const translateBodies = async (
  lang: string,
  body: string[]
): Promise<string[]> => {
  const res = await instance.post<{ lang: string; body: string[] }>(
    'translations/translate',
    { lang, body }
  );

  return res.data?.body || [];
};
